import { Building2 } from "lucide-react";

import useAuth from "@/hooks/useAuth";

/**
 * Landing for an external user whose portfolio grants neither sales nor
 * revenue. Deliberately ungated — every CapabilityGuard redirects here, so
 * gating it would loop.
 */
function NoPropertyAccess() {
  const { signOut } = useAuth();

  return (
    <div className="flex min-h-[60vh] items-center justify-center px-6 py-12">
      <div className="max-w-md text-center">
        <div className="mx-auto mb-5 flex h-14 w-14 items-center justify-center rounded-full bg-primary-light">
          <Building2 size={26} className="text-primary" />
        </div>
        <h1 className="m-0 text-xl font-bold tracking-[-0.01em] text-text-heading">
          No tools available yet
        </h1>
        <p className="mx-auto mt-3 max-w-sm text-sm leading-relaxed text-text-secondary">
          None of the properties in your portfolio are on a contract that
          includes the tools in this portal. Your Atica POC can tell you
          what&apos;s available on your current plan.
        </p>
        <button
          type="button"
          onClick={signOut}
          className="mt-6 rounded-md border border-border-dark bg-surface-surface px-4 py-2 text-sm font-semibold text-text-secondary transition-colors hover:border-text-heading hover:bg-text-heading hover:text-white"
        >
          Sign out
        </button>
      </div>
    </div>
  );
}

export default NoPropertyAccess;
